import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { getInitials } from 'signin-app/util/get-initials';
import * as CheckOutSelectors from 'signin-app/child/check-out/selectors';
import { HeaderPerson } from './header-person';
import useTypedSelector from './hooks/use-typed-selector';
export const HeaderChild = ({ child }) => {
    const isDataLimited = useTypedSelector(CheckOutSelectors.limitedData);
    const childName = React.useMemo(() => (isDataLimited ? child.name.firstName : child.name.fullName), [child.name.firstName, child.name.fullName, isDataLimited]);
    const initials = React.useMemo(() => getInitials(childName), [childName]);
    return _jsx(HeaderPerson, { image: child.image.small, initials: initials, name: childName });
};
